module.exports = __webpack_public_path__ + "static/media/fr.a700795b.svg";